const DevicesWidth = {
  mobileMaxWidth: 767,
  tablet: { minWidth: 768, maxWidth: 1199 },
  rotatedTablet: { minWidth: 1000, maxWidth: 1199 },
  desktopMinWidth: 1200,
  ratio: 1.4
};

export default DevicesWidth;
